import { useState } from "react";

import { cn } from "@bentolabs/kit/utils";
import { useAccount } from "wagmi";

import { ConnectWalletButton } from "features/connect-wallet";
import { CreateRefLinkDialog } from "features/create-ref-link";
import Share from "shared/assets/share.svg?react";
import { useResponsive } from "shared/hooks/use-responsive";
import { Button } from "shared/ui/button";

type Props = {
  className?: string;
};

export const ReferralPanel = (props: Props) => {
  const { className } = props;

  const [isOpen, setIsOpen] = useState(false);

  const { isConnected } = useAccount();

  const { md } = useResponsive();

  // const buildCommandMutation = useBuildCommandMutation();
  // const sendMessageMutation = useSendMessageMutation();

  const handleShare = () => {
    setIsOpen(true);
    // buildCommandMutation.mutate();
    // sendMessageMutation.mutate();
  };

  const button = isConnected ? (
    <Button variant="spearmint" onClick={handleShare}>
      Share
    </Button>
  ) : (
    <ConnectWalletButton />
  );

  return (
    <div
      style={{
        boxShadow: "0px 1px 1px 0px #22ED4E33 inset",
        background:
          "linear-gradient(360deg, rgba(34, 237, 78, 0.15) 0%, rgba(34, 237, 78, 0.06) 100%)",
      }}
      className={cn(
        "relative flex w-full flex-col gap-y-4 overflow-hidden rounded-3xl p-3 md:flex-row md:py-0 md:pr-0",
        className
      )}
    >
      <div className="flex items-center gap-x-3">
        <div className="flex size-12.5 items-center justify-center rounded-xl bg-black">
          <Share className="size-9" />
        </div>
        <div className="flex flex-col">
          <div className="leading text-lg leading-[105%]">
            Share your referral link
          </div>
          <div className="text-nobel/70 mt-1 text-sm leading-[150%]">
            Earn 10% of referee’s total points.
          </div>
        </div>
      </div>
      {md ? (
        <div className="bg-spearmint/2 ml-auto flex w-1/2 rounded-[20px]">
          <div className="bg-spearmint/4 ml-auto flex w-3/4 rounded-[20px]">
            <div className="bg-spearmint/6 ml-auto flex w-8/12 rounded-[20px]">
              <div className="bg-spearmint/8 ml-auto rounded-[20px] p-4.5 pl-5">
                {button}
              </div>
            </div>
          </div>
        </div>
      ) : (
        button
      )}

      <CreateRefLinkDialog isOpen={isOpen} onOpenChange={setIsOpen} />
    </div>
  );
};
